import { render, staticRenderFns } from "./addstudentDialog.vue?vue&type=template&id=7a59a8c4&scoped=true&"
import script from "./addstudentDialog.vue?vue&type=script&lang=js&"
export * from "./addstudentDialog.vue?vue&type=script&lang=js&"
import style0 from "./addstudentDialog.vue?vue&type=style&index=0&id=7a59a8c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a59a8c4",
  null
  
)

export default component.exports